import { Component, Input, OnInit } from "@angular/core";
import { Booker, BookingInfo } from "app/shared/model/splitPaymentDetails";
import { AuthService } from "app/shared/module/auth/auth.service";

@Component({
  selector: "pf-split-payments-success",
  templateUrl: "./split-payments-success.component.html",
  styleUrls: ["./split-payments-success.component.scss"],
})
export class SplitPaymentsSuccessComponent implements OnInit {
  @Input("metadata") metadata: BookingInfo;
  @Input("booker") booker: Booker;
  @Input("attendeeEmail") email: string;

  constructor(public authService: AuthService) {}
  ngOnInit(): void {}
}
